// src/App.tsx  — production routing with LandingPage as “/”
// ---------------------------------------------------------
import React from 'react';
import {
 BrowserRouter as Router,
 Routes,
 Route,
 Navigate,
} from 'react-router-dom';


/* ─── Context ──────────────────────────────────────────── */
import { AuthProvider } from './contexts/AuthContext';


/* ─── Route guard ──────────────────────────────────────── */
import ProtectedRoute from './components/common/ProtectedRoute';


/* ─── Public / marketing pages ─────────────────────────── */
import LandingPage   from './components/marketing/LandingPage';
import WaitlistPage  from './components/marketing/WaitlistPage'; // still reachable at /waitlist



/* ─── Auth pages ───────────────────────────────────────── */
import Login          from './components/auth/Login';
import Register       from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import MyAccount from './components/account/MyAccount';


/* ─── Dashboard & event tools ──────────────────────────── */
import Dashboard        from './components/dashboard/Dashboard';
import CreateEvent      from './components/events/CreateEvent';
import CreateEventFromTemplate from './components/events/CreateEventFromTemplate';
import EditEvent        from './components/events/EditEvent';
import EventDetails     from './components/events/EventDetails';
import ManageGuestsPage from './components/events/ManageGuestsPage';
import ContactsPage     from './components/contacts/ContactsPage';


/* ─── Invitation flow ─────────────────────────────────── */
import ViewInvitation from './components/recipients/ViewInvitation';
import InviteRouter   from './components/invite/InviteRouter';
import EndPage        from './components/invite/EndPage';
import InvitePreviewRoute from './components/invite/InvitePreviewRoute';

/* ─── Legal pages ──────────────────────────────────────── */
import TermsAndConditions from './components/legal/TermsAndConditions';
import PrivacyPolicy from './components/legal/PrivacyPolicy';

function App() {
 return (
   <AuthProvider>
     <Router>
       <Routes>
         {/* ── Public landing / hero page ─────────────────────── */}
         <Route path="/" element={<LandingPage />} />
         {/* Optional: keep the old wait‑list at /waitlist */}
         <Route path="/waitlist" element={<WaitlistPage />} />


         {/* ── Auth (public) ───────────────────────────────────── */}
         <Route path="/login"           element={<Login />} />
         <Route path="/register"        element={<Register />} />
         <Route path="/forgot-password" element={<ForgotPassword />} />

         {/* ── Legal pages (public) ────────────────────────────── */}
         <Route path="/terms"   element={<TermsAndConditions />} />
         <Route path="/privacy" element={<PrivacyPolicy />} />

         {/* ── Invite flow (public) ───────────────────────────── */}
         <Route path="/recipients/:uniqueCode" element={<ViewInvitation />} />
         <Route path="/invite/:code"           element={<InviteRouter />} />
         <Route path="/invite/:code/end"       element={<EndPage status="accepted" />} />
         <Route path="/preview-invitation" element={<InvitePreviewRoute />} />


         {/* ── Event creation (allowed even if anonymous) ─────── */}
         <Route path="/create-event" element={<CreateEvent />} />
         <Route path="/create-event-from-template" element={<CreateEventFromTemplate />} />

         {/* ── Protected area – requires logged‑in user ───────── */}
         <Route
           path="/dashboard"
           element={
             <ProtectedRoute>
               <Dashboard />
             </ProtectedRoute>
           }
         />
         <Route
            path="/account"
            element={
              <ProtectedRoute>
                <MyAccount />
              </ProtectedRoute>
            }
          />
         <Route
           path="/edit-event/:eventId"
           element={
             <ProtectedRoute>
               <EditEvent />
             </ProtectedRoute>
           }
         />
         <Route
           path="/event/:eventId"
           element={
             <ProtectedRoute>
               <EventDetails />
             </ProtectedRoute>
           }
         />
         <Route
           path="/event/:eventId/guests"
           element={
             <ProtectedRoute>
               <ManageGuestsPage />
             </ProtectedRoute>
           }
         />
         <Route
           path="/contacts"
           element={
             <ProtectedRoute>
               <ContactsPage />
             </ProtectedRoute>
           }
         />


         {/* ── Catch‑all → landing page ───────────────────────── */}
         <Route path="*" element={<Navigate to="/" replace />} />
       </Routes>
     </Router>
   </AuthProvider>
 );
}


export default App;



